<script setup lang="ts">
import { computed } from 'vue';
import LazyVisible from '@/components/common/lazy-visible.vue';
import PickedUpArticles from '@/components/home/picked-up-articles.vue';
import { useThemeKeywordFeedCounts, useThemeList } from '@/utils/swr';
import { useStore } from '@/utils/vue';

const store = useStore();
const feedType = computed(() => store.state.feedType.feedType);

const { data: themeKeywordFeedCounts } = useThemeKeywordFeedCounts(feedType);

const getThemeKeywordFeedCount = (themeId: number) =>
  themeKeywordFeedCounts.value?.theme_keyword_feed_counts[String(themeId)] ?? 0;

const { data: themes } = useThemeList(feedType);
const favoriteThemes = computed(() =>
  [...(themes.value?.themes ?? [])]
    .filter(t => !t.is_deleted && t.is_favorite)
    .sort((a, b) => a.order - b.order),
);
</script>
<template>
  <div class="o-picked-up-feeds">
    <div class="o-themes" v-if="favoriteThemes.length > 0">
      <LazyVisible
        class="o-theme"
        v-for="theme in favoriteThemes"
        :key="theme.id"
      >
        <PickedUpArticles
          :theme="theme"
          :article-count="getThemeKeywordFeedCount(theme.id)"
        ></PickedUpArticles>
      </LazyVisible>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.o-picked-up-feeds {
  .o-themes {
    .o-theme {
      content-visibility: auto;
      contain-intrinsic-size: auto 600px;

      &:not(:first-child) {
        margin-top: 16px;
      }
    }
  }
}

.o-theme-name {
  color: $color-gray1000;
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>
